import { MobileApp } from "@/libraries/design/patterns";
import { RichTextComponent } from "@/libraries/design/utils";

export interface UniformMobileAppProps {
    title: string;
    description?: string;
    richText?: string;
    linkLabel?: string;
    linkHref?: string;
    imageSrc: string;
    imageAlt?: string;
    appleAppStoreUrl: string;
    googlePlayStoreUrl: string;
}

const UniformMobileApp = (props: UniformMobileAppProps) => {
    return (
        <MobileApp
            title={props.title}
            description={
                props.richText ? (
                    <RichTextComponent text={props.richText} />
                ) : (
                    props.description
                )
            }
            linkLabel={props.linkLabel}
            linkHref={props.linkHref}
            imageSrc={props.imageSrc}
            imageAlt={props.imageAlt}
            appleAppStoreUrl={props.appleAppStoreUrl}
            googlePlayStoreUrl={props.googlePlayStoreUrl}
        />
    );
};

export default UniformMobileApp;
